import React, { useEffect, useRef } from 'react';
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "./Tokenomics.css";
import { useLanguage } from "../../context/LanguageContext";
import { getT } from "../../translations";

gsap.registerPlugin(ScrollTrigger);

function Tokenomics() {
  const sectionRef = useRef(null);
  const headerRef = useRef(null);
  const contractRef = useRef(null);
  const gridRef = useRef(null);
  const { lang } = useLanguage();
  const t = getT(lang);
  const handleCopy = () => {
    navigator.clipboard.writeText("FQN4yCNYgZ2hjJKeUzeYzewvSxNVTUBnosECeqh7pump");
    alert(t("tokenomics.copied"));
  };

  useEffect(() => {
    const section = sectionRef.current;
    const header = headerRef.current;
    const contract = contractRef.current;
    const grid = gridRef.current;
    if (!section || !header) return;
    const boxes = grid ? grid.querySelectorAll(".info-box") : [];
    gsap.set([header, contract, ...boxes], { opacity: 0, y: 24 });
    const tl = gsap.timeline({
      scrollTrigger: { trigger: section, start: "top 78%", toggleActions: "play none none none" },
    });
    tl.to(header, { opacity: 1, y: 0, duration: 0.5, ease: "power2.out" })
      .to(contract, { opacity: 1, y: 0, duration: 0.4, ease: "power2.out" }, "-=0.2")
      .to(boxes, { opacity: 1, y: 0, duration: 0.35, stagger: 0.1, ease: "power2.out" }, "-=0.2");
    return () => ScrollTrigger.getAll().forEach((t) => t.kill());
  }, []);

  return (
    <section id='tokenomics' className="tokenomics-section" ref={sectionRef}>
      <div className="tok-container">
        <h1 ref={headerRef} className="tok-header">{t("tokenomics.header")}</h1>

        <div ref={contractRef} className="contract-box">
          <input
            type="text"
            value="FQN4yCNYgZ2hjJKeUzeYzewvSxNVTUBnosECeqh7pump"
            readOnly
            className="contract-input"
          />
          <button className="copy-btn" onClick={handleCopy}>{t("tokenomics.copy")}</button>
        </div>

        <div ref={gridRef} className="info-grid">
          <div className="info-box">
            <p className="info-title">{t("tokenomics.ticker")}</p>
            <p className="info-value">$奶龙</p>
          </div>
          <div className="info-box">
            <p className="info-title">{t("tokenomics.chain")}</p>
            <p className="info-value">SOL</p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Tokenomics;
